const initialInsuranceManager = {
    insuranceManagerPermissions:{},
    insuranceManagerLists: [],
    insuranceManagerHighlightedRecord: null,
    insuranceManagerListsid:[],
    insuranceManagerStatus: [],
    changedInsuranceManagerStatus : [],
    loadingInsuranceManager: false,
    errorsInsuranceManager: {},
    updateId:"",
    message:"",
}

const  insuranceManagerReducer = (insuranceManager = initialInsuranceManager, action) => {
    switch (action.type) {
        case "GET_INSURANCE_MANAGERLIST_PENDING":
        case "ADD_INSURANCE_MANAGER_PENDING":
        case "UPDATE_INSURANCE_MANAGER_PENDING":
        case "UPDATE_INSURANCE_MANAGER_STATUS_PENDING":
        case "DELETE_INSURANCE_MANAGER_PENDING":
        case "GET_INSURANCE_MANAGERLISTBYID_PENDING":
            return { ...insuranceManager, loadingInsuranceManager: true, errorsInsuranceManager: {} };
            case "SET_MESSAGE":
                return { ...insuranceManager,
                    message:action.payload 
                };
                case "EDIT_INSURANCEMANAGER_FORM_CLOSED":
                    return { 
                        ...insuranceManager, 
                        updateId:"",
                        insuranceManagerListsid :[],
                        errorsInsuranceManager:{},
                    };
        case "GET_INSURANCE_MANAGERLIST_FULFILLED":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
               insuranceManagerLists: action.payload,
                insuranceManagerCount: action.count,
                insuranceManagerPermissions:action.permissions,
            };

        case "ADD_INSURANCE_MANAGER_FULFILLED":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
                changedInsuranceManagerStatus: action.payload,
                insuranceManagerListsid:action.payload?.data,
                updateId:action.payload?.data?.id  || insuranceManager.updateId,
                errorsInsuranceManager: {},
                message: action.payload?.message,
            };

        case "UPDATE_INSURANCE_MANAGER_FULFILLED":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
                changedInsuranceManagerStatus: action.payload,
                insuranceManagerListsid:action.payload?.data,
                updateId:action.payload?.data?.id  || insuranceManager.updateId,
                errorsInsuranceManager: {},
                message: action.payload?.message,

            };

        case "UPDATE_INSURANCE_MANAGER_STATUS_FULFILLED":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
                changedInsuranceManagerStatus: action.payload,
            };
            case "EDIT_INSURANCEMANAGER_FORM_FULFILLED":
                return { 
                    ...insuranceManager, 
                    updateId:action.payload,
                    insuranceManagerListsid:action.payload,
                    message:""
                };

        case "GET_INSURANCE_MANAGERLISTBYID_FULFILLED":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
                insuranceManagerListsid: action.payload,
                updateId:action.payload?.id,
            };

        case "DELETE_INSURANCE_MANAGER_FULFILLED":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
                changedInsuranceManagerStatus: action.payload
            };

        case "RESET_DELETE_INSURANCE_MANAGER_STATUS":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
                insuranceManagerStatus:{},
                changedInsuranceManagerStatus: [],
                errorsInsuranceManager:{}
            };

        case "GET_INSURANCE_MANAGERLIST_REJECTED":
         case "ADD_INSURANCE_MANAGER_REJECTED":
        case "UPDATE_INSURANCE_MANAGER_REJECTED":
        case "UPDATE_INSURANCE_MANAGER_STATUS_REJECTED":
        case "DELETE_INSURANCE_MANAGER_REJECTED":
        case "GET_INSURANCE_MANAGERLISTBYID_REJECTED":
            return {
                ...insuranceManager,
                loadingInsuranceManager: false,
                errorsInsuranceManager: action.payload
            };
        case "SET_INSURANCE_MANAGER_HIGHLIGHTED_RECORD":
            return { ...insuranceManager, insuranceManagerHighlightedRecord: action.payload };
        case "CLEAR_INSURANCE_MANAGER_HIGHLIGHTED_RECORD":
            return { ...insuranceManager, insuranceManagerHighlightedRecord: null };
        default:
            return insuranceManager;
    }
}

export default insuranceManagerReducer;